import React from 'react';
import { IconAlert } from './BuilderUiIcons';
import './ErrorMessage.css';

function ErrorMessage({ message, onRetry }) {
  return (
    <div className="error-message">
      <div className="error-icon" aria-hidden>
        <IconAlert className="error-icon-svg" />
      </div>
      <div className="error-content">
        <h3 className="error-title">We couldn&apos;t complete that request</h3>
        <p className="error-text">{message}</p>
        {onRetry && (
          <button className="retry-btn" onClick={onRetry}>
            Try Again
          </button>
        )}
      </div>
    </div>
  );
}

export default ErrorMessage;
